// components
import headerLandingPage from '@/components/landing-page/header/Header.vue';
import Segments from '@/components/landing-page/segments/Segments.vue';
import Categories from '@/components/landing-page/categories/Categories.vue';
import Processes from '@/components/landing-page/processes/Processes.vue';
import Metrics from '@/components/landing-page/metrics/Metrics.vue';
import Quotes from '@/components/landing-page/quotes/Quotes.vue';
import Logos from '@/components/landing-page/logos/Logos.vue';
import $ from 'jquery'; // eslint-disable-line
export default {
    name: 'LandnigPage',
    components: {
        Header: headerLandingPage,
        Segments,
        Categories,
        Processes,
        Metrics,
        Quotes,
        Logos
    },
    data: () => ({
        components: ['Header', 'Segments', 'Categories', 'Processes', 'Quotes', 'Metrics', 'Logos']
    })
};
